export const NAVIGATION_ROUTES = {
  LOGIN: "/",
  USERS: "/users/home",
  USERS_NEW: "/users-new",
  PLAYERS: "/players",
  USER_MANAGER: "/users/manager",
  SPORTSBOOK: "/sportsbook",
  SPORTSBOOK_BETS_REPORT: "/sportsbook-bets-report",
  KPIS: "/kpis",
  REPORTING_SUMMARY: "/sportsbook/reporting/reporting-summary",
  /** Drill-down under `REPORTING_SUMMARY` (same `/sportsbook/reporting/reporting-summary` base path). */
  REPORTING_SUMMARY_PROFITABILITY:
    "/sportsbook/reporting/reporting-summary/profitability/:date",
  AFFILIATES: "/affiliates",
  ADMIN: "/admin",
  CREATE_ACCOUNT: "/create-account",
  CUSTOMER_SUPPORT_CONTROLS: "/customer-support-controls",
  DASHBOARD: "/dashboard",
  EVENTS: "/events",
  /** Fieldbook → Events List (PAM sidebar). */
  FIELDBOOK_EVENTS_LIST: "/sportsbook/fieldbook/events-list",
  /** Monitoring → Latest Bets List (PAM sidebar). */
  MONITORING_LATEST_BETS_LIST: "/sportsbook/monitoring/latest-bets-list",
  /** Configuration → Bet Settings (PAM sidebar). */
  CONFIGURATION_BET_LIMITS: "/sportsbook/configuration/bet-settings",
  /** Configuration → Account Config (DynamoDB snapshot / row edits). */
  CONFIGURATION_ACCOUNT_CONFIG: "/sportsbook/configuration/account-config",
  /** Configuration → Early Payout (placeholder). */
  CONFIGURATION_EARLY_PAYOUT: "/sportsbook/configuration/early-payout",
  STAFF_MANAGEMENT: "/staff-management",
  STAFF_MANAGEMENT_NEW: "/staff-management-new",
  MANUAL_ENTRIES: "/manual-entries",
  AGENT_AUDIT_LOG: "/agent-audit-log",
  PAYMENTS: "/payments",
  /** Payments → Reports (Payment Reporting dashboard). */
  PAYMENT_REPORTING: "/payments/reports",
  /** Payments → Configuration → Limits (dev-only scaffolding). */
  PAYMENTS_CONFIGURATION_LIMITS: "/payments/configuration/limits",
  FINIX_DELAYED_PAYMENT: "/finix-delayed-payment",
  PRIZE_REDEMPTION_MANUAL_REVIEW: "/prize-redemption-manual-review",
  PRIZE_REDEMPTION_MANUAL_REVIEW_TRACKING:
    "/prize-redemption-manual-review-tracking",
  PROMOTIONS: "/promotions",
  LOCATIONS_RESTRICTIONS: "/locations-restrictions",
  FEATURE_MANAGEMENT: "/feature-management",
  REPORTS: "/reports",
  /** Promotions → Affiliates (GA — Affiliates components). */
  MARKETING_AFFILIATES: "/promotions/marketing-affiliates",
  /** Affiliate creation page reached from the "New Affiliate" CTA. */
  MARKETING_AFFILIATE_NEW: "/promotions/marketing-affiliates/new",
  /** Affiliate detail page reached from the Affiliates table name cell. */
  MARKETING_AFFILIATE_PROFILE: "/promotions/marketing-affiliates/:affiliateId",
  /** Promotions → UTM Reports. */
  UTM_REPORTS: "/promotions/utm-reports",
  CASINO: "/casino",
  /** Casino → Reports → Finance (PAMENG-1720). */
  CASINO_FINANCE_REPORTS: "/casino/reports/finance",
  CASINO_REPORTS_PROVIDERS: "/casino/reports/providers",
  CASINO_REPORTS_GAMES: "/casino/reports/games",
  /** [Product] → Reports → Top Users (whitelisted; one per product). */
  SPORTSBOOK_TOP_USERS: "/sportsbook/reporting/top-users",
  CASINO_TOP_USERS: "/casino/reports/top-users",
  POKER_TOP_USERS: "/poker/reports/top-users",
  POKER_CONFIGURATION_CASH_GAME_LIMITS: "/poker/configuration/cash-game-limits",
  POKER_CONFIGURATION_STAKES: "/poker/configuration/stakes",
  POKER_CONFIGURATION_PRIVATE_GAMES: "/poker/configuration/private-games",
  POKER_CONFIGURATION_TOURNAMENTS: "/poker/configuration/tournaments",
  POKER_CONFIGURATION_TIMEBANK: "/poker/configuration/timebank",
  POKER_CONFIGURATION_FEATURES: "/poker/configuration/features",
  GAME_PASS: "/game-pass",
  /** Game Pass → Configuration → Seasons listing. */
  GAME_PASS_CONFIGURATION_SEASONS: "/game-pass/configuration/seasons",
  /** Game Pass → Configuration → Seasons → Create Season wizard. */
  GAME_PASS_SEASON_NEW: "/game-pass/configuration/seasons/new",
  /** Game Pass → Configuration → Seasons → Season Details (per-season view). */
  GAME_PASS_SEASON_DETAILS: "/game-pass/configuration/seasons/:seasonId",
  /** Game Pass → Configuration → Monthly (Monthly Challenges configuration landing). */
  GAME_PASS_CONFIGURATION_MONTHLY: "/game-pass/configuration/monthly",
  /** Game Pass → Configuration → Monthly → Create Monthly Challenge wizard. */
  GAME_PASS_MONTHLY_NEW: "/game-pass/configuration/monthly/new",
  /** Game Pass → Configuration → Monthly → Monthly Challenge Details (per-challenge view). */
  GAME_PASS_MONTHLY_DETAILS: "/game-pass/configuration/monthly/:challengeId",
  /** Game Pass → Configuration → Style (theming: colors, assets, preview). */
  GAME_PASS_CONFIGURATION_STYLE: "/game-pass/configuration/style",
  PROMOTIONS_MANAGEMENT: "/promotions-management",
  TRANSACTIONS_WALLET: "/transactions-wallet",
  TRANSACTIONS_REPORTS: "/transactions-reports",
  TRANSACTIONS_ROUTING: "/payments/configuration/routing",
  EVENT_DETAILS: "/event-details",
  BETS_TYPES_LIST: "/bets-types-list",
  SGP_RISK: "/sportsbook/monitoring/sgp-risk",
  SPORTSBOOK_LIMITS: "/sportsbook/configuration/sgp-limits",
  DELAYED_PAYMENT: "/payments/configuration/delayed-payment",
  CASINO_FM: "/casino/configurations/casino-fm",
  CASINO_CONFIGURATION_GAMES: "/casino/configuration/games",
  CASINO_CONFIGURATION_PROVIDERS: "/casino/configuration/providers",
  CASINO_CONFIGURATION_CATALOGS: "/casino/configuration/catalogs",
  CASINO_CONFIGURATION_VIEWS: "/casino/configuration/views",
  CASINO_CONFIGURATION_PAGES: "/casino/configuration/pages",
  CASINO_CONFIGURATION_TAGS: "/casino/configuration/tags",
  CASINO_CONFIGURATION_PREVIEW: "/casino/configuration/preview",
  CASINO_CONFIGURATION_FEATURES: "/casino/configuration/features",
  SPORTSBOOK_FM: "/sportsbook/configuration/sportsbook-fm",
  CASINO_BANNER_CREATION: "/casino-banner-creation",
  WITHDRAWAL_REVIEW: "/withdrawal-review",
  WITHDRAWAL_REVIEW_LEGACY_V2: "/withdrawal-review-v2",
  WITHDRAWAL_REVIEW_LEGACY_RULES: "/withdrawal-review/rules",
  WITHDRAWAL_REVIEW_LEGACY_ADD_RULE: "/withdrawal-review/rules/add",
  WITHDRAWAL_REVIEW_LEGACY_EDIT_RULE: "/withdrawal-review/rules/edit",
  MOBILE_BUILD_DOWNLOADS: "/mobile-build-downloads",
  PROVIDER_DETAILS: "/casino/provider-details",
  SET_PASSWORD: "/set-password",
  RESET_PASSWORD: "/reset-password",
  FRAUD_DETECTION: "/fraud-detection",
  FRAUD_DETECTION_EDIT_RULE: "/fraud-detection/edit-rule",
  DUPLICATE_IDENTITY_REVIEW: "/duplicate-identity-review",
  /** Predictions → Reports (dev-only scaffolding). */
  PREDICTIONS_REPORTS: "/predictions/reports",
  /** Predictions → Configuration (dev-only scaffolding). */
  PREDICTIONS_CONFIGURATION: "/predictions/configuration",
  /**
   * Configurations → Profile / Feature Quick Access (FE-2349).
   * Gated by `configurations.profile` + TCM product `core_app`, and by
   * `featureFlag: "featureQuickAccess"` on the route.
   * There is no `features.quick_access` permission.
   */
  CONFIGURATIONS_PROFILE: "/configurations/profile",
  /**
   * Configurations → State Configuration (PENG-78). Per-US-state experience
   * config (Prediction vs Sweepstakes, signup age, per-product toggles).
   * Gated by `configurations.state_configuration` + `developmentMode` until
   * the backend endpoints ship.
   */
  CONFIGURATIONS_STATE_CONFIGURATION: "/configurations/state-configuration",
  /**
   * Configurations → Scheduled Tasks (CASENG-1048). Manual trigger + run
   * history. Purposes are casino-only today, so the route keeps the casino
   * permission/product gates.
   */
  CONFIGURATIONS_SCHEDULED_TASKS: "/configurations/scheduled-tasks",
  /**
   * Configurations → KYC Configuration (VER-346). SURT checkpoint toggles.
   * Gated by `compliance` (route-level, via `protectedElement`) plus both the
   * `surt` and `surtCheckpoints` flags. The flag gate lives in the page itself
   * — `ConfigurationPage` redirects to `/` when either is off — not in the
   * App.js route table, because `protectedElement`'s `featureFlag` option
   * takes a single flag and these two are AND-ed. Either off and neither the
   * route nor the sidebar entry is reachable.
   */
  CONFIGURATIONS_KYC: "/configurations/kyc",
  /**
   * @deprecated The KYC page used to live under Compliance. App.js redirects
   * this path to `CONFIGURATIONS_KYC` so older links keep working; do not use
   * it for new links.
   */
  CONFIGURATIONS_KYC_LEGACY: "/compliance/configuration",
  /** Compliance → Maintenance Mode (web + mobile toggles). */
  COMPLIANCE_MAINTENANCE_MODE: "/compliance/maintenance-mode",
  /** Dynamic Bonuses — Campaigns list page. */
  DYNAMIC_BONUS_CAMPAIGNS: "/promotions/dynamic-bonuses/campaigns",
  /** Dynamic Bonuses — Create Campaign page. */
  DYNAMIC_BONUS_CAMPAIGN_NEW: "/promotions/dynamic-bonuses/campaigns/new",
  /**
   * Dynamic Bonuses — Create Affiliate Campaign page. In App.js this static
   * route must be declared before DYNAMIC_BONUS_CAMPAIGN_DETAIL so
   * `new-affiliate` isn't captured as a `:campaignId`.
   */
  DYNAMIC_BONUS_CAMPAIGN_NEW_AFFILIATE: "/promotions/dynamic-bonuses/campaigns/new-affiliate",
  /** Dynamic Bonuses — Campaign detail page. */
  DYNAMIC_BONUS_CAMPAIGN_DETAIL: "/promotions/dynamic-bonuses/campaigns/:campaignId",
  /** Dynamic Bonuses — Templates list page. */
  DYNAMIC_BONUS_TEMPLATES: "/promotions/dynamic-bonuses/templates",
  /** Dynamic Bonuses — Create Template page. */
  DYNAMIC_BONUS_TEMPLATE_NEW: "/promotions/dynamic-bonuses/templates/new",
  /** Dynamic Bonuses — Edit Template page. */
  DYNAMIC_BONUS_TEMPLATE_EDIT: "/promotions/dynamic-bonuses/templates/:templateId/edit",
  /** Dynamic Bonuses — Segments list page. */
  DYNAMIC_BONUS_SEGMENTS: "/promotions/dynamic-bonuses/segments",
  /** Dynamic Bonuses — Create Segment page. */
  DYNAMIC_BONUS_SEGMENT_NEW: "/promotions/dynamic-bonuses/segments/new",
  /** Dynamic Bonuses — Segment detail page. */
  DYNAMIC_BONUS_SEGMENT_DETAIL: "/promotions/dynamic-bonuses/segments/:segmentId",
  /**
   * Dynamic Bonuses — Series detail page (BONENG-842). Reached from series
   * rows in the Campaigns list — series have no sider entry or list/create
   * routes of their own; authoring goes through the Create Campaign wizard.
   */
  DYNAMIC_BONUS_SERIES_DETAIL: "/promotions/dynamic-bonuses/series/:seriesId",
  /**
   * Dynamic Bonuses — Edit Series page. Reuses CreateCampaignWizard + PUT.
   * Declared before DYNAMIC_BONUS_SERIES_DETAIL is not required (different
   * path pattern with `/edit` suffix), but keep edit registration first in
   * App.js for consistency with other static-before-param routes.
   */
  DYNAMIC_BONUS_SERIES_EDIT: "/promotions/dynamic-bonuses/series/:seriesId/edit",
};

/** @param {string} isoDate `YYYY-MM-DD` calendar day for the reporting row */
export function buildReportingSummaryProfitabilityPath(isoDate) {
  return `${NAVIGATION_ROUTES.REPORTING_SUMMARY}/profitability/${encodeURIComponent(isoDate)}`;
}

/**
 * @param {string} [affiliateId]
 * @returns {string} Affiliate profile path; falls back to the affiliates list
 *   when no id is provided.
 */
export function buildAffiliateProfilePath(affiliateId) {
  if (affiliateId == null) return NAVIGATION_ROUTES.MARKETING_AFFILIATES;
  const id = String(affiliateId).trim();
  if (!id) return NAVIGATION_ROUTES.MARKETING_AFFILIATES;
  return `${NAVIGATION_ROUTES.MARKETING_AFFILIATES}/${encodeURIComponent(id)}`;
}

/** Query param for `/staff-management-new` deep links (PAM `admin_id`). */
export const STAFF_MANAGEMENT_STAFF_ID_QUERY_KEY = "staff_id";

/** Query param for `/fraud-detection/edit-rule` (fraud rule `id`). */
export const FRAUD_DETECTION_RULE_ID_QUERY_KEY = "id";

/** Query param for `/users/manager` when opening a specific user (see `UserManager.js`). */
export const USER_MANAGER_USER_ID_QUERY_KEY = "userId";
export const USERS_FILTER_QUERY_PREFIX = "filters";

export function buildUsersFiltersUrl(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, rawValue]) => {
    const value = String(rawValue ?? "").trim();
    if (key && value) {
      params.set(`${USERS_FILTER_QUERY_PREFIX}[${key}]`, value);
    }
  });

  const query = params.toString();
  return query ? `${NAVIGATION_ROUTES.USERS}?${query}` : NAVIGATION_ROUTES.USERS;
}

/**
 * @param {string} [userId]
 * @returns {string} Path with `userId` query when provided, otherwise the manager base path.
 */
export function buildUserManagerUrl(userId) {
  if (userId == null) return NAVIGATION_ROUTES.USER_MANAGER;
  const id = String(userId).trim();
  if (!id) return NAVIGATION_ROUTES.USER_MANAGER;
  const params = new URLSearchParams();
  params.set(USER_MANAGER_USER_ID_QUERY_KEY, id);
  return `${NAVIGATION_ROUTES.USER_MANAGER}?${params.toString()}`;
}
